import { gql } from '@apollo/client';

const INITIATE_STRIPE_CONNECT = gql`
  mutation InitiateStripeConnect($refreshUrl: String!, $returnUrl: String!) {
    initiateStripeConnect(refreshUrl: $refreshUrl, returnUrl: $returnUrl) {
      success
      errors
      onboardingUrl
      stripeConnectAccountId
      stripeConnectVerified
    }
  }
`;

const UPDATE_PRODUCT_HOST = gql`
  mutation UpdateProductHost(
    $addressEntityId: ID = ""
    $availableAtLocation: Boolean!
    $availableHousecalls: Boolean!
    $availableOnline: Boolean!
    $isActive: Boolean!
    $isTraveling: Boolean = false
    $note: String = ""
    $uuid: ID!
  ) {
    updateProductHost(
      addressEntityId: $addressEntityId
      availableAtLocation: $availableAtLocation
      availableHousecalls: $availableHousecalls
      availableOnline: $availableOnline
      isActive: $isActive
      isTraveling: $isTraveling
      note: $note
      uuid: $uuid
    ) {
      success
      errors
      productHost {
        uuid
        availableAtLocation
        availableHousecalls
        availableOnline
        isInTraining
        isTraveling
        note
        isActive
        createdAt
        updatedAt
        locationDetails {
          uuid
          uuid
          name
          showInDirectory
          thirdPartyAddress
          locationPhotoUrl
          address {
            uuid
            addressLine1
            addressLine2
            addressLine3
            city
            zone
            postalCode
            attention
            coordinates
            isOrg
            region {
              id
              name
            }
            category {
              id
              name
              description
            }
          }
        }
      }
    }
  }
`;

const APPROVE_HOST_TASK = gql`
  mutation ApproveHostTask($hostTaskUuid: ID!) {
    approveHostTask(hostTaskUuid: $hostTaskUuid) {
      success
      errors
    }
  }
`;

const REVISE_HOST_TASK = gql`
  mutation ReviseHostTask($hostTaskUuid: ID!, $content: JSON!, $title: String) {
    reviseHostTask(hostTaskUuid: $hostTaskUuid, content: $content, title: $title) {
      success
      errors
    }
  }
`;

const UPLOAD_HOST_TASK_FILE = gql`
  mutation UploadHostTaskFile($hostTaskUuid: ID!, $file: Upload!, $approve: Boolean) {
    uploadHostTaskFile(hostTaskUuid: $hostTaskUuid, file: $file, approve: $approve) {
      success
      errors
    }
  }
`;

const REGENERATE_HOST_TASK_FILE = gql`
  mutation RegenerateHostTaskFile($hostTaskUuid: ID!) {
    regenerateHostTaskFile(hostTaskUuid: $hostTaskUuid) {
      success
      errors
    }
  }
`;

export {
  INITIATE_STRIPE_CONNECT,
  UPDATE_PRODUCT_HOST,
  APPROVE_HOST_TASK,
  REVISE_HOST_TASK,
  UPLOAD_HOST_TASK_FILE,
  REGENERATE_HOST_TASK_FILE,
};
